import React, { useState } from 'react'
import { ItemsRequestModel } from '.'
import SectionBoxContainer from '../../components/SectionBoxContainer'
import BasicDataViewer, { IBasicDataViewItem } from '../../components/DataDisplayer/BasicDataViewer'
import RequestDesignation from './RequestDesignation'
import RequestDestination from './RequestDestination'
import RequestDestinationAddress from './RequestDestinationAddress'
import { ILocationModel } from '../locations/LocationsApp'

interface IReguestDetailedDestinationProps {
    request: ItemsRequestModel,
}

export default function ReguestDetailedDestination(props: IReguestDetailedDestinationProps) {

    const { request } = props

    let description: string = request.action_type === "move" ? "Here you can the items destination, where they will be moved permanently." : "Here you can the items destination, where they will be used temporarily."

    const [location, setLocation] = useState<ILocationModel | null>(null)

    let items: IBasicDataViewItem[] = [
        {
            type: "text",
            value: "",
            label: "Destination:",
            customContent: () => {
                return <RequestDestination request={request} />
            },
            displayLabelNextLine: true,
        },
    ]

    if (request.designation_type !== "user"){
        items = [
            ...items,
            {
                type: "text",
                value: "",
                label: "Address:",
                customContent: () => {
                    return <h3><RequestDestinationAddress request={request} returnAsText updateLocation={(location) => setLocation(location)} /></h3>
                },
                displayLabelNextLine: true,
            },
            {
                type: "map",
                value: location ? location.maps_link : "",
                label: "Google Maps:",
                displayLabelNextLine: true,
            },
        ]
    }

    return(
        <div className="request-detailed-destination">
            <SectionBoxContainer
                showTitle
                title="Items Destination"
                description={description}
            >
                <BasicDataViewer items={items} />
            </SectionBoxContainer>
        </div>
    )
}